import React from 'react';
import AppModal from '../common/AppModal';

const ClientViewConfirmModal = ({
  show,
  onHide,
  onConfirm,
  staffName,
  clientName,
  submitting = false,
  title = 'Confirm action'
}) => (
  <AppModal
    show={show}
    onHide={submitting ? undefined : onHide}
    onSubmit={onConfirm}
    heading={title}
    submitting={submitting}
    submitLabel="Confirm"
  >
    <p className="mb-0">
      This will be recorded as done by <strong>{staffName} (Accurate)</strong> on behalf of{' '}
      <strong>{clientName}</strong>.
    </p>
  </AppModal>
);

export default ClientViewConfirmModal;
